import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap'
import Avatar from 'material-ui/Avatar';
import RaisedButton from 'material-ui/RaisedButton';
import Add from 'material-ui/svg-icons/content/add';
import firebaseApp from '../../firebase/firebase';
import Toggle from 'material-ui/Toggle';
import {Card, CardTitle, CardText } from 'material-ui/Card';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';

class Profile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      newName: '',
      newPhone: ''
    }
  }

  componentDidMount() {
    firebaseApp.database().ref(`users/${this.props.user.uid}`).on('value', snapshot => {
      console.log(snapshot.val().meta.realtor);
    })
  }

  handleNewName = (name, user) => {
    user.updateProfile({
      displayName: name,
    }).then(() => {
      console.log('success');
    }).catch((error) => {
      console.log(error)
    });
  }

  handleImage = (image, user) => {
    const storageRef = firebaseApp.storage().ref();
    storageRef.child(`images/${user.uid}/profileImage`).put(image)
    .then( snapshot => {
      const downloadURL = snapshot.downloadURL;
      user.updateProfile({
        photoURL: downloadURL
      }).then(() => {
         console.log('success');
      }).catch((error) => {
        console.log(error)
      });
    })
  }

render() {

  const styles = {
    uploadButton: {
      verticalAlign: 'middle',
    },
    uploadInput: {
      cursor: 'pointer',
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      width: '100%',
      opacity: 0,
    },
  };

  console.log(this.props.user);
  return (
    <Grid fluid style={{ marginTop: 5 }}>
      <Row>
        <Col xs={12} sm={12} md={12} lg={3}>
          <Card style={{textAlign: 'center', borderRadius: 10 }}>
            <CardText>
              <div>
                  <Avatar
                    icon={!this.props.user.photURL? <Add /> : null}
                    src={this.props.user.photoURL? this.props.user.photoURL : null}
                    size={200}
                    style={{ borderRadius: 2,}}
                    onClick={() => console.log('add profile pic')}
                   />
              </div>
              <div style={{}}>

                <h2 contentEditable="true"
                  onInput={(e) => this.setState({ newName: e.target.innerText})}
                  onFocus={(e) => console.log('you have entered')}
                  onBlur={(e) => this.handleNewName(this.state.newName, this.props.user)}> {!this.props.user.displayName? 'No Name' : this.props.user.displayName }
                </h2>

                <h5> {this.props.user.email} </h5>
                  <RaisedButton containerElement='label' label={'Upload Image'}  fullWidth={true} labelStyle={{ fontSize: 12 }} style={{marginBottom: 11, marginTop: 11 }}>
                    <input type="file" style={styles.uploadInput} onChange={(e) => this.handleImage(e.target.files[0], this.props.user )}/>
                  </RaisedButton>

              </div>
            </CardText>
          </Card>
        </Col>
        <Col xs={12} sm={12} md={12} lg={9}>
          <Card style={{ borderRadius: 10 }}>
            <CardTitle title={'Preferred Vendors'} />
            <CardText>
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHeaderColumn>Name</TableHeaderColumn>
                    <TableHeaderColumn>Email</TableHeaderColumn>
                    <TableHeaderColumn>Phone</TableHeaderColumn>
                    <TableHeaderColumn>Company</TableHeaderColumn>
                    <TableHeaderColumn>Title</TableHeaderColumn>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  <TableRow>
                    <TableRowColumn>Justin Matthew</TableRowColumn>
                    <TableRowColumn>jmatthew@terminatix.com</TableRowColumn>
                    <TableRowColumn>901-123-4567</TableRowColumn>
                    <TableRowColumn>Terminatix</TableRowColumn>
                    <TableRowColumn>Lead Inspector</TableRowColumn>
                  </TableRow>
                  <TableRow>
                    <TableRowColumn>Andrew Rogers</TableRowColumn>
                    <TableRowColumn>andrew@servicecap.co</TableRowColumn>
                    <TableRowColumn>901-254-8909</TableRowColumn>
                    <TableRowColumn>ServiceCapital</TableRowColumn>
                    <TableRowColumn>Loan Counselor</TableRowColumn>
                  </TableRow>
                  <TableRow>
                    <TableRowColumn>Andrew Fowlkes</TableRowColumn>
                    <TableRowColumn>afowlkes@awfcu.org</TableRowColumn>
                    <TableRowColumn>901-517-4657</TableRowColumn>
                    <TableRowColumn>American Way FCU</TableRowColumn>
                    <TableRowColumn>Mortgage Underwriter</TableRowColumn>
                  </TableRow>
                  <TableRow>
                    <TableRowColumn>Michael Shipman</TableRowColumn>
                    <TableRowColumn>mship@rc.com</TableRowColumn>
                    <TableRowColumn>901-239-1618</TableRowColumn>
                    <TableRowColumn>Regal Contractors</TableRowColumn>
                    <TableRowColumn>Construction Manager</TableRowColumn>
                  </TableRow>
                </TableBody>
              </Table>
              <RaisedButton label="Add Vendor" primary={true} style={{ marginTop: 25 }}/>
              &nbsp;
              &nbsp;
              <RaisedButton label="Export to CSV" secondary={true} style={{ marginTop: 25 }}/>
            </CardText>
          </Card>
        </Col>
      </Row>
    </Grid>
  )
}

}

const mapStateToProps = ({auth}) => {
  const { user } = auth;
  return { user }

}

export default connect(mapStateToProps, {})(Profile);



// WEBPACK FOOTER //
// ./src/components/profile/index.js